"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendEmail = void 0;
const invokeapi_1 = require("./invokeapi");
const sendEmail = async (message) => {
    const response = await (0, invokeapi_1.invokeapi)("email/process", {
        method: "POST",
        body: message,
    });
    return response;
};
exports.sendEmail = sendEmail;
